"use strict";
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.EuraDatePicker = void 0;
const react_1 = __importDefault(require("react"));
const dayjs_1 = __importDefault(require("rc-picker/lib/generate/dayjs"));
const generatePicker_1 = __importDefault(require("antd/lib/date-picker/generatePicker"));
require("../styles/eura-datepicker.css");
const Icons_1 = require("./Icons");
const DatePicker = (0, generatePicker_1.default)(dayjs_1.default);
/**
 * Wrapattu AntD:n DatePicker-komponentti.
 * Propsikuvaus: https://ant.design/components/date-picker/#API
 * @param props
 */
const EuraDatePicker = (props) => {
    var _a;
    const { className, dropdownClassName } = props, other = __rest(props, ["className", "dropdownClassName"]);
    const classConstruct = ['eura-date-picker', className !== null && className !== void 0 ? className : ''].join(' ');
    const drClassConstruct = ['eura-date-picker__dropdown', dropdownClassName !== null && dropdownClassName !== void 0 ? dropdownClassName : ''].join(' ');
    const pickerType = (_a = props.picker) !== null && _a !== void 0 ? _a : 'date';
    switch (pickerType) {
        case 'date':
            return (react_1.default.createElement(DatePicker, Object.assign({ suffixIcon: react_1.default.createElement(Icons_1.CalendarIcon, null), className: classConstruct, dropdownClassName: drClassConstruct }, other, { picker: pickerType })));
        case 'week':
            return (react_1.default.createElement(DatePicker.WeekPicker, Object.assign({ suffixIcon: react_1.default.createElement(Icons_1.CalendarIcon, null), className: classConstruct, dropdownClassName: drClassConstruct }, other)));
        case 'month':
            return (react_1.default.createElement(DatePicker.MonthPicker, Object.assign({ suffixIcon: react_1.default.createElement(Icons_1.CalendarIcon, null), className: classConstruct, dropdownClassName: drClassConstruct }, other)));
        case 'quarter':
            return (react_1.default.createElement(DatePicker.QuarterPicker, Object.assign({ suffixIcon: react_1.default.createElement(Icons_1.CalendarIcon, null), className: classConstruct, dropdownClassName: drClassConstruct }, other)));
        case 'year':
            return (react_1.default.createElement(DatePicker.YearPicker, Object.assign({ suffixIcon: react_1.default.createElement(Icons_1.CalendarIcon, null), className: classConstruct, dropdownClassName: drClassConstruct }, other)));
        case 'time':
            return (react_1.default.createElement(DatePicker.TimePicker, Object.assign({ suffixIcon: react_1.default.createElement(Icons_1.CalendarIcon, null), className: classConstruct, dropdownClassName: drClassConstruct }, other)));
        default:
            return react_1.default.createElement(react_1.default.Fragment, null);
    }
};
exports.EuraDatePicker = EuraDatePicker;
